import React, { FC } from 'react';
import { ConfigContext, ConfigContextShape } from './ConfigContext';

interface ConfigContextProviderProps {
  initialState: {
    config: ConfigContextShape;
  };
}

export const ConfigContextProvider: FC<ConfigContextProviderProps> = ({ initialState, children }) => {
  const contextValue: ConfigContextShape = {
    ...initialState.config,
  };

  return <ConfigContext.Provider value={contextValue}>{children}</ConfigContext.Provider>;
};
